import { connect } from 'react-redux';
import { CampaignViewTracker } from './CampaignViewTracker';
import { updateCampaignViews } from '../../redux/campaign/actions';

const actions = { updateCampaignViews };

export default connect(null, actions)(CampaignViewTracker);
